const EmptyState = ({ title, message, icon }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      {icon && <div className="mb-4 text-gray-300">{icon}</div>}
      <h3 className="text-lg font-medium text-gray-900 mb-1">{title}</h3>
      {message && <p className="text-sm text-gray-500">{message}</p>}
    </div>
  )
}

export default EmptyState
